import { Text } from 'foundations-components/components/Text';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Overlay } from 'foundations-components/transitional/components/Overlay';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LoadingOverlayWithMessage = ({
  message
}) => {
  return /*#__PURE__*/_jsx(Overlay, {
    use: "dark",
    width: "100%",
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      justifyContent: "center",
      blockSize: "100%",
      children: [/*#__PURE__*/_jsx(Flex, {
        blockSize: "1300",
        children: /*#__PURE__*/_jsx(LoadingSpinner, {
          grow: true
        })
      }), /*#__PURE__*/_jsx(Text, {
        as: "h5",
        color: "fill-surface-default",
        textAlign: "center",
        children: message
      })]
    })
  });
};
export default LoadingOverlayWithMessage;